enum AccessOrderPaymentStatusesEnum {
  INITIAL = 'INITIAL',
  INVOICE_PENDING = 'INVOICE_PENDING',
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  PAID = 'PAID',
}

export default AccessOrderPaymentStatusesEnum;
